﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.DisposeService
 * @description
 * # DisposeService
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('DisposeService', ['ForecastService', 'ForecastingFiltersProvider', function (ForecastService, ForecastingFiltersProvider) {


      function getServices() {
          return [ForecastService, ForecastingFiltersProvider];
      }

      function dispose() {
          getServices().forEach(function (service) {
              
              if (service.Dispose) {
                  service.Dispose();
              }
          });
      }

      var service = {};

      service.Dispose = dispose;

      return service;
  }]);